// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

const companyID = JSON.parse(localStorage.getItem('companyID'))

export const getData = createAsyncThunk('clientreference/getData', async (params) => {
     
         
  const response = await axios.post('https://api.zasway.com:8443/ClientReference/GetTableSummary', params, {mode:'cors'})
   
    
  return {
  params,
  data: response.data.data,
  allData: response.data.allData,
  totalPages: response.data.total
  }
})

export const addClientReference = createAsyncThunk('client/Create',  async (Client, {dispatch}) => {
    
  const response = await axios.post('https://api.zasway.com:8443/ClientReference/Create', Client, {mode:'cors'})
  await dispatch(getData({
    companyID, 
    userID: 0, 
    id: 0, 
    page: 0, 
    perPage: 10
  }))
return response
})

export const editClientReference  = createAsyncThunk('client/editClientReference', async (Client) => {
      
  const response = await axios.post('https://api.zasway.com:8443/ClientReference/Update', Client, {mode:'cors'})
  return response
})
export const getrefClientReferencetype  = createAsyncThunk('client/getrefClientReferencetype', async (Client) => {
      
  const response = await axios.post('https://api.zasway.com:8443/Client/GetRefClientReferenceTypeList', Client, {mode:'cors'})
  return response
})

 export const referenceClient = createAsyncThunk('clientreference/referenceClient', async (params) => {
      
  const response = await axios.post('https://api.zasway.com:8443/ClientReference/GetTableSummary', params, {mode:'cors'})
    
  return {
    params,
    data: response.data.data, 
    allData: response.data.allData,
    totalPages: response.data.total
  }
  })

  export const resetreferenceClientEditData = createAsyncThunk('clientreference/resetreferenceClientEditData', async () => {
     
    return {data:[]}
  })

  export const getreferenceClientEditData = createAsyncThunk('clientreference/getreferenceClientEditData', async (params) => {
     
     
    const response = await axios.post('https://api.zasway.com:8443/ClientReference/GetTableSummary', params, {mode:'cors'})
    return {data:response.data.data}
  })

  export const EditreferenceClient = createAsyncThunk('clientreference/Update', async (Client, {dispatch}) => {
    const response = await axios.post('https://api.zasway.com:8443/ClientReference/Update', Client, {mode:'cors'})
    await dispatch(getData({
        companyID, 
        userID: 0, 
        id: 0, 
        page: 0, 
        perPage: 10
      }))
    return response
})


  export const deletereferenceClient = createAsyncThunk('clientreference/Delete', async (id, { dispatch, getState }) => {
                  
    const response = await axios.post('https://api.zasway.com:8443/ClientReference/Delete', id, {mode:'cors'})
     
    await dispatch(getData(getState().ReferenceClient.params))
    
    return response
})

  export const ClientReferenceSlice = createSlice({
    name: 'clientreference',
    initialState: {
      data: [],
      total: 1,
      params: {},
      allData: [],
      selectedUser: null,
      referenceClientEditData: []
    },
    reducers: {},
  extraReducers: builder => {
    builder
    .addCase(getData.fulfilled, (state, action) => {
      state.data = action.payload.data
      state.allData = action.payload.allData
      state.total = action.payload.totalPages
      state.params = action.payload.params
  })
      .addCase(referenceClient.fulfilled, (state, action) => {
          
        state.data = action.payload.data
        state.params = action.payload.params
        state.allData = action.payload.allData
        state.total = action.payload.totalPages
      })
      .addCase(getreferenceClientEditData.fulfilled, (state, action) => {
         
        state.referenceClientEditData = action.payload.data
      })
      .addCase(resetreferenceClientEditData.fulfilled, (state, action) => {
              
        state.referenceClientEditData = action.payload.data
      })
    }
  })

  export default ClientReferenceSlice.reducer